const DashboardAdapter = (
  leadsNotifications,
  leadsCallback,
  qualityNotifications,
  qualityCallback,
  duplicatesNotifications,
  duplicatesCallback,
  reportsNotifications,
  reportsCallback,
  reportsTotalCallback,
  downloadPostingsQualityCallback
) => {
  const widgetList = [
    {
      name: 'leads',
      icon: 'Consultas',
      order: leadsNotifications ? 0 : 4,
      text: 'panel.dashboard.widget.leads.text',
      completeText: 'panel.dashboard.widget.leads.text.complete',
      completeTitle: 'panel.dashboard.widget.leads.title.complete',
      ctaText: 'panel.dashboard.widget.leads.cta.text',
      tooltip: 'panel.dashboard.widget.leads.tooltip',
      tooltipComplete: 'panel.dashboard.widget.leads.tooltip.complete',
      notifications: leadsNotifications,
      ctaCallback: leadsCallback
    },
    {
      name: 'quality',
      icon: 'Calidad',
      order: qualityNotifications ? 1 : 4,
      text: 'panel.dashboard.widget.quality.text',
      completeText: 'panel.dashboard.widget.quality.text.complete',
      completeTitle: 'panel.dashboard.widget.quality.title.complete',
      ctaText: 'panel.dashboard.widget.quality.cta.text',
      tooltip: 'panel.dashboard.widget.quality.tooltip',
      tooltipComplete: 'panel.dashboard.widget.quality.tooltip.complete',
      notifications: qualityNotifications,
      ctaCallback: qualityCallback,
      linkText: 'panel.dashboard.widget.quality.linktext',
      linkCallback: downloadPostingsQualityCallback
    },
    {
      name: 'duplicated',
      icon: 'Duplicados',
      order: duplicatesNotifications ? 2 : 4,
      text: 'panel.dashboard.widget.duplicates.text',
      completeText: 'panel.dashboard.widget.duplicates.text.complete',
      completeTitle: 'panel.dashboard.widget.duplicates.title.complete',
      ctaText: 'panel.dashboard.widget.duplicates.cta.text',
      tooltip: 'panel.dashboard.widget.duplicates.tooltip',
      tooltipComplete: 'panel.dashboard.widget.duplicates.tooltip.complete',
      notifications: duplicatesNotifications,
      ctaCallback: duplicatesCallback
    },
    {
      name: 'reports',
      icon: 'Reportes',
      order: reportsNotifications ? 3 : 4,
      text: 'panel.dashboard.widget.reports.text',
      completeText: 'panel.dashboard.widget.reports.text.complete',
      completeTitle: 'panel.dashboard.widget.reports.title.complete',
      ctaText: 'panel.dashboard.widget.reports.cta.text',
      tooltip: 'panel.dashboard.widget.reports.tooltip',
      tooltipComplete: 'panel.dashboard.widget.reports.tooltip.complete',
      notifications: reportsNotifications,
      ctaCallback: reportsCallback,
      linkText: 'panel.dashboard.widget.reports.linktext',
      linkCallback: reportsTotalCallback
    }
  ];

  return widgetList.sort((a, b) => {
    return a.order - b.order;
  });
};

export default DashboardAdapter;
